import { render, staticRenderFns } from "./total-student-attendance.vue?vue&type=template&id=e9ed5130&scoped=true"
import script from "./total-student-attendance.vue?vue&type=script&lang=js"
export * from "./total-student-attendance.vue?vue&type=script&lang=js"
import style0 from "./total-student-attendance.vue?vue&type=style&index=0&id=e9ed5130&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9ed5130",
  null
  
)

export default component.exports